export var FsEntryType;
(function (FsEntryType) {
    // Follow the order in the C++ FsEntry::Type
    FsEntryType["FILE"] = "file";
    FsEntryType["DIR"] = "dir";
    FsEntryType["LINK"] = "link";
})(FsEntryType || (FsEntryType = {}));
export var RemoteUploadState;
(function (RemoteUploadState) {
    RemoteUploadState["CLEAN"] = "clean";
    RemoteUploadState["DIRTY"] = "dirty";
    RemoteUploadState["STUCK"] = "stuck";
})(RemoteUploadState || (RemoteUploadState = {}));
export class FsLimits {
    data;
    entries;
    storage;
    externalFilesSize;
    externalFilesCount;
    constructor(data, entries, storage, externalFilesSize, externalFilesCount) {
        this.data = data;
        this.entries = entries;
        this.storage = storage;
        this.externalFilesSize = externalFilesSize;
        this.externalFilesCount = externalFilesCount;
    }
    isUnlimited() {
        return (this.data == 0n &&
            this.entries == 0n &&
            this.storage == 0n &&
            this.externalFilesSize == 0n &&
            this.externalFilesCount == 0n);
    }
    isEqual(other) {
        return (this.data === other.data &&
            this.entries === other.entries &&
            this.storage === other.storage &&
            this.externalFilesSize === other.externalFilesSize &&
            this.externalFilesCount === other.externalFilesCount);
    }
}
